import { Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import * as React from "react";
import EditAppComponent from "./EditAppComponent";
import EditPackageComponent from "./EditPakageComponent";
import { createDayTimeFormat } from "@/utils/timeFormat";
import { applicationDetailInfoType } from "types/app";
import { useTranslation } from "react-i18next";

interface IMainSectionProps {
	ApplicationDetailInfo: applicationDetailInfoType;
	setApplicationDetailInfo: (value: applicationDetailInfoType) => void;
	translationObject: any;
}

const MainSection: React.FC<IMainSectionProps> = ({
	ApplicationDetailInfo,
	setApplicationDetailInfo,
	translationObject,
}) => {
	const { app } = ApplicationDetailInfo;
	const [editAppName, setEditAppName] = React.useState("");
	const [editPackageName, setEditPackageName] = React.useState({
		packageAndroid: "",
		packageIos: "",
	});
	const { t } = useTranslation();
	const [openEditAppComponent, setOpenEditAppComponent] = React.useState(false);
	const [openEditPackageComponent, setOpenEditPackageComponent] = React.useState(false);

	React.useEffect(() => {
		setEditAppName(app.name);
		setEditPackageName({
			packageAndroid: app.packageAndroid,
			packageIos: app.packageIos,
		});
	}, [app.name]);
	return (
		<div style={{ margin: "3rem 2rem" }}>
			<Typography
				sx={{ color: "#545351", fontSize: "1.2rem", marginBottom: "1rem" }}
			>
				{translationObject("application_setting.title")}
			</Typography>
			<div
				className="MainSection__Container"
				style={{ border: "2px solid #E0E0E0", backgroundColor: "#FFFFFF" }}
			>
				<div
					className="ApplicationName"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "1.5rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "40%",
							display: "inline-block",
						}}
					>
						{translationObject("application_setting.name")}
					</span>

					<TextField
						value={editAppName}
						id="outlined-name"
						sx={{ width: "60%" }}
						onChange={(e) => {
							setEditAppName(e.target.value);
							setOpenEditAppComponent(true);
						}}
					/>
				</div>
				{openEditAppComponent && (
					<EditAppComponent
						setEditAppName={setEditAppName}
						appObjectName={app.name}
						editAppName={editAppName}
						appObjectId={app.id}
						setOpenEditAppComponent={setOpenEditAppComponent}
					/>
				)}
				<div style={{ border: "1px solid #E0E0E0" }} />
				<div
					className="CreateDate"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "1.5rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "40%",
							display: "inline-block",
						}}
					>
						{translationObject("application_setting.created_at")}
					</span>
					<span>{app.createdAt && createDayTimeFormat(app.createdAt)}</span>
				</div>
				<div style={{ border: "1px solid #E0E0E0" }} />
				<div
					className="PakageName"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "1.5rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "40%",
							display: "inline-block",
							alignSelf: "flex-start",
						}}
					>
						{translationObject("application_setting.package")}
					</span>
					<div style={{ width: "60%", display: "flex" }}>
						<div style={{ flexGrow: 1 }}>
							<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
								Android
							</Typography>

							<TextField
								id="outlined-basic"
								variant="outlined"
								size="small"
								sx={{ width: "95%" }}
								value={editPackageName.packageAndroid}
								disabled={app.packageAndroid !== ""}
								placeholder={t(
									"application_detail.pleseinput_package_android",
								)}
								onChange={(e) => {
									setEditPackageName({
										...editPackageName,
										packageAndroid: e.target.value,
									});
									setOpenEditPackageComponent(true);
								}}
							/>
						</div>
						<div style={{ flexGrow: 1 }}>
							<Typography sx={{ color: "#0d0d0d94", textAlign: "left" }}>
								iOS
							</Typography>
							<TextField
								id="outlined-basic"
								variant="outlined"
								size="small"
								sx={{ width: "95%" }}
								value={editPackageName.packageIos}
								disabled={app.packageIos !== ""}
								placeholder={t(
									"application_detail.pleseinput_package_ios",
								)}
								onChange={(e) => {
									setEditPackageName({
										...editPackageName,
										packageIos: e.target.value,
									});
									setOpenEditPackageComponent(true);
								}}
							/>
						</div>
					</div>
				</div>
				{openEditPackageComponent && (
					<EditPackageComponent
						editPackageName={editPackageName}
						setEditPackageName={setEditPackageName}
						appObject={{
							packageAndroid: app.packageAndroid,
							packageIos: app.packageIos,
						}}
						appObjectId={app.id}
						appObjectName={app.name}
						setOpenEditPackageComponent={setOpenEditPackageComponent}
						setApplicationDetailInfo={setApplicationDetailInfo}
						ApplicationDetailInfo={ApplicationDetailInfo}
					/>
				)}
			</div>
		</div>
	);
};

export default MainSection;
